import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import type {ReactNode} from 'react';

export const queryClient = new QueryClient({
  defaultOptions: {queries: {staleTime: 10_000, retry: false}}
});

export function AppQueryProvider({children}: {children: ReactNode}) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
